<template>
  <div id="app" :class="$store.state.isDark ? 'dark': ''">
    <router-view/>
  </div>
</template>
<script>
export default {}
</script>